import { useState } from "react";

const STANDARD_TERMS = [7, 15, 30, 45, 60, 90];

// Payment Terms picker: Net 7/15/30/45/60/90, or Custom with an explicit day
// count. Value is always the plain day count (what the backend stores) —
// this component only changes how the admin picks it.
export default function PaymentTermSelect({ value, onChange, disabled }) {
  const isStandard = STANDARD_TERMS.includes(Number(value));
  const [mode, setMode] = useState(isStandard || !value ? "standard" : "custom");

  const handleSelectChange = (e) => {
    const selected = e.target.value;
    if (selected === "custom") {
      setMode("custom");
      return;
    }
    setMode("standard");
    onChange(Number(selected));
  };

  return (
    <div>
      <select
        value={mode === "custom" ? "custom" : (isStandard ? String(value) : "")}
        onChange={handleSelectChange}
        disabled={disabled}
        className="border rounded-lg px-3 py-2 text-sm w-full"
      >
        <option value="" disabled>
          Select payment term
        </option>
        {STANDARD_TERMS.map((days) => (
          <option key={days} value={days}>
            Net {days}
          </option>
        ))}
        <option value="custom">Custom</option>
      </select>

      {mode === "custom" && (
        <input
          type="number"
          min="1"
          placeholder="Number of days"
          value={!isStandard ? value : ""}
          onChange={(e) => onChange(Number(e.target.value))}
          disabled={disabled}
          className="border rounded-lg px-3 py-2 text-sm w-full mt-2"
        />
      )}
    </div>
  );
}
